import React from 'react';
import { useLoaderData } from 'react-router-dom';
import ListPageHeader from '@shared/ListPageHeader';
import PartnerApiLogShow from '@shared/partner_api_logs/PartnerApiLogShow';

export default function AdminPartnerApiLogsShow() {
  const log = useLoaderData();

  return (
    <div>
      <ListPageHeader basePath="/admin" items={['developer_tools', 'developer_tools.partner_api_logs', { label: log?.id?.slice(0, 8) }]} />
      <PartnerApiLogShow log={log} />
    </div>
  );
}
